<template>
  <b-container
    fluid
    class="container-with-sidebar container-with-sidebar-admin"
  >
    <admin-sidebar :collapsed="false"></admin-sidebar>
    <router-view :key="$route.path"></router-view>
  </b-container>
</template>

<script>
import AdminSidebar from "@/components/Admin/Sidebar";
import jwtMixin from "@/mixins/jwtMixin";

export default {
  name: "BaseAdmin",
  components: {
    AdminSidebar,
  },
  mixins: [jwtMixin],
  created() {
    this.setCssVariables();
    this.$i18n.locale = this.jwtLanguage();
    this.$i18n.fallbackLocale = this.jwtLanguage();
    //window.addEventListener("resize", debounce(this.setCssVariables, 300));
    window.addEventListener(
      "resize",
      this._.debounce(this.setCssVariables, 300)
    );
  },
  methods: {
    getDimensions() {
      return {
        width: 0.01 * window.innerWidth,
        height: 0.01 * window.innerHeight,
      };
    },
    setCssVariables() {
      let dimensions = this.getDimensions();
      let width = dimensions.width;
      let height = dimensions.height;
      document.documentElement.style.setProperty("--vw", width + "px");
      document.documentElement.style.setProperty("--vh", height + "px");
    },
  },
};
</script>

<style lang="scss" scoped>
.admin-container {
  padding-left: 5%;
  padding-right: 5%;
}
</style>
